import React from 'react';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import MakeReservation from '../../../components/shared/make-reservation/make-reservation';
import { BookingPageStyled } from './booking.page.styled';
import { useSelector } from 'react-redux';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';
import { useParams } from 'react-router-dom';

const BookingPage = () => {
  const params = useParams();

  const { loading } = useSelector((state: any) => {
    return state.makeReservation;
  });

  return (
    <Dashboard callingPage={'BookingPage'}>
      <BookingPageStyled.Container>
        <MakeReservation roomSelected={params.id} />
        <LinearLoading loading={loading} />
      </BookingPageStyled.Container>
    </Dashboard>
  );
};

export default BookingPage;
